import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LegalLinks } from "./Legal";
import { NAV, AUTH } from "../constants/testIds";
import { Home, Map, BookOpen, User, Shield, LogOut, TrendingUp } from "lucide-react";

export default function StudentLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/giris"); };
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A] pb-24">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-[#E2E8F0]">
        <div className="max-w-5xl mx-auto px-5 py-3 flex items-center justify-between">
          <NavLink to="/" data-testid={NAV.brand} className="flex items-center gap-2.5">
            <img src="/brand/yz-logo.png" alt="YZ Matematik"
                 className="h-9 w-9 rounded-full object-cover ring-2 ring-[#FFC107]/70 shadow-sm" />
            <span className="font-display text-xl tracking-tight">
              <span className="text-[#0B1A35]">YZ</span>{" "}
              <span className="text-[#C99700]">Matematik</span>
            </span>
          </NavLink>
          <div className="flex items-center gap-3 text-sm">
            {user?.role === "admin" && (
              <NavLink to="/admin" data-testid={NAV.admin}
                className="hidden sm:inline-flex items-center gap-1 px-3 py-1.5 rounded-full border border-[#E2E8F0] hover:border-[#007BFF] hover:text-[#007BFF] transition-colors">
                <Shield size={14} /> Yönetim
              </NavLink>
            )}
            <span className="hidden sm:inline text-slate-500">{user?.name}</span>
            <button data-testid={AUTH.logoutBtn} onClick={onLogout}
              className="p-2 rounded-full hover:bg-slate-100" aria-label="Çıkış">
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6">
        <Outlet />
        <LegalLinks className="mt-10" />
      </main>
      <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-[#E2E8F0] bg-white/95 backdrop-blur-xl">
        <div className="max-w-5xl mx-auto grid grid-cols-5">
          {[
            { to: "/", label: "Panel", icon: Home, tid: NAV.dashboard, end: true },
            { to: "/konular", label: "Konular", icon: BookOpen, tid: NAV.topics },
            { to: "/harita", label: "Harita", icon: Map, tid: NAV.map },
            { to: "/gelisim", label: "Gelişim", icon: TrendingUp, tid: NAV.progress },
            { to: "/profil", label: "Profil", icon: User, tid: NAV.profile },
          ].map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} data-testid={it.tid}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-2.5 text-xs transition-colors ${isActive ? "text-[#0B1A35] font-semibold" : "text-slate-500"}`
              }>
              {({ isActive }) => (
                <>
                  <span className={`grid place-items-center w-10 h-7 rounded-full transition-colors ${isActive ? "bg-[#FFF3C4]" : ""}`}>
                    <it.icon size={20} />
                  </span>
                  {it.label}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
